import React from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormHelperText from '@material-ui/core/FormHelperText';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import PropTypes from 'prop-types';
import ReactDOM from 'react-dom';
import Utils from '../../../../../utils';

export default class SelectMui3Field extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            labelWidth: 0
        };
    }
    componentDidMount() {
        this.setState({
            labelWidth: ReactDOM.findDOMNode(this.InputLabelRef).offsetWidth // eslint-disable-line
        });
    }
    componentDidUpdate() {
        if (ReactDOM.findDOMNode(this.InputLabelRef).offsetWidth !== this.state.labelWidth) { // eslint-disable-line
            this.setState({
                labelWidth: ReactDOM.findDOMNode(this.InputLabelRef).offsetWidth // eslint-disable-line
            });
        }
    }
    render() {
        const {
            id,
            title,
            options,
            emptyValue,
            error,
            placeholder,
            multiple,
            errorText,
            helperText,
            required,
            disabled,
            inputValue,
            onBlur,
            onFocus,
            valueOptions,
            uiSchema
        } = this.props;

        const { classes = {} } = uiSchema;
        const onChange = event => {
            const target = event.target;
            const value = target.value;
            const selectOptions = target.options;

            // native selects return string values
            // MUI multiple selects returns array,
            // to handle the same way, extract the selected options
            if (!multiple || (Utils.isArray(value) && !options.native)) {
                return this.props.onChange(id, value === '' ? emptyValue : value);
            }

            const selectedValues = [];

            for (let i = 0, l = selectOptions.length; i < l; i += 1) {
                if (selectOptions[i].selected) {
                    selectedValues.push(selectOptions[i].value);
                }
            }

            return this.props.onChange(id, selectedValues);
        };

        const selectOptions = [];

        if (placeholder !== null) {
            if (options.native) {
                selectOptions.push(<option key={`${id}-option-empty`} value="">{ placeholder }</option>);
            } else {
                selectOptions.push(<MenuItem key={`${id}-option-empty`} value="">{ placeholder }</MenuItem>);
            }
        }

        valueOptions.forEach((valueOption, i) => {
            const { key, label } = valueOption;
            const optionDisabled = disabled ? disabled : valueOption.disabled;

            if (options.native) {
                selectOptions.push(
                    <option disabled={ optionDisabled } key={`${id}-option-${i}`} value={ key }>{ label }</option>
                );
            } else {
                selectOptions.push(
                    <MenuItem disabled={ optionDisabled } key={`${id}-option-${i}`} value={ key }>{ label }</MenuItem>
                );
            }
        });

        return (
            <React.Fragment>
                <FormControl
                    required={ required }
                    error={ error }
                    component="fieldset"
                    variant={ options.variant || 'outlined'}
                    classes={{
                        root: classes.fieldSet || ''
                    }}
                >
                    <InputLabel
                        ref={ref => {
                            this.InputLabelRef = ref;
                        }}
                        htmlFor={ id }
                    >
                        { title }
                    </InputLabel>
                    <Select
                        id={ id }
                        native={ options.native }
                        label={ title }
                        classes={{
                            root: classes.selectField || ''
                        }}
                        multiple={ multiple }
                        variant={ options.variant ? options.variant : 'outlined' }
                        onChange={ !disabled ? onChange : null }
                        placeholder={ placeholder }
                        error={ error }
                        required={ required }
                        disabled={ disabled }
                        value={ inputValue || '' }
                        onBlur={ onBlur && (event => onBlur({ id, value: event.target.value })) }
                        onFocus={ onFocus && (event => onFocus({ id, value: event.target.value })) }
                        input={
                            <OutlinedInput
                                name={ title }
                                id={ id }
                                labelWidth={this.state.labelWidth}
                            />
                        }
                    >
                        { selectOptions }
                    </Select>
                    { helperText ? <FormHelperText
                        classes={{
                            root: classes.helperContainer || ''
                        }}
                    >{ helperText }</FormHelperText> : null }
                    { errorText ? <FormHelperText
                        classes={{
                            root: classes.errorContainer || ''
                        }}
                    >{ errorText }</FormHelperText> : null }
                </FormControl>
            </React.Fragment>
        );
    }
}

SelectMui3Field.propTypes = {
    id: PropTypes.string.isRequired,
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    emptyValue: PropTypes.any,
    placeholder: PropTypes.any,
    error: PropTypes.bool,
    errorText: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    multiple: PropTypes.bool,
    options: PropTypes.shape({
        variant: PropTypes.string,
        native: PropTypes.bool
    }),
    valueOptions: PropTypes.arrayOf(PropTypes.shape({
        key: PropTypes.string.isRequired,
        label: PropTypes.string.isRequired,
        disabled: PropTypes.bool
    })),
    uiSchema: PropTypes.shape({
        classes: PropTypes.shape({
            fieldSet: PropTypes.string,
            helperContainer: PropTypes.string,
            errorContainer: PropTypes.string,
            selectField: PropTypes.string
        })
    }),
    inputValue: PropTypes.any,
    onBlur: PropTypes.func,
    onFocus: PropTypes.func,
    helperText: PropTypes.string,
    onChange: PropTypes.func
};

SelectMui3Field.defaultProps = {
    title: '',
    emptyValue: '',
    placeholder: null,
    error: false,
    errorText: '',
    required: false,
    disabled: false,
    multiple: false,
    options: {
        variant: 'outlined',
        native: true
    },
    valueOptions: [],
    uiSchema: {},
    inputValue: '',
    helperText: ''
};
